import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "card-body p-9 pb-12" }
const _hoisted_5 = {
  key: 0,
  class: "text-primary fw-bolder"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-light btn-icon btn-sm",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3 m-0" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-three-dots fs-3" })
  ])
], -1)
const _hoisted_7 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary w-auto min-w-150px fw-bold",
  "data-kt-menu": "true"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-3 opacity-75" }, null, -1)
const _hoisted_9 = {
  key: 0,
  class: "menu-item px-3"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "separator mt-3 opacity-75" }, null, -1)
const _hoisted_11 = {
  key: 1,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_12 = { class: "card-header" }
const _hoisted_13 = { class: "card-title m-0" }
const _hoisted_14 = { class: "card-body p-9 pb-12" }
const _hoisted_15 = {
  key: 0,
  class: "text-primary fw-bolder"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-light btn-icon btn-sm",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3 m-0" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-three-dots fs-3" })
  ])
], -1)
const _hoisted_17 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary w-auto min-w-150px fw-bold",
  "data-kt-menu": "true"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-3 opacity-75" }, null, -1)
const _hoisted_19 = {
  key: 0,
  class: "menu-item px-3"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "separator mt-3 opacity-75" }, null, -1)
const _hoisted_21 = {
  key: 2,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_22 = { class: "card-header" }
const _hoisted_23 = { class: "card-title m-0" }
const _hoisted_24 = { class: "card-body p-9 pb-12" }
const _hoisted_25 = {
  key: 0,
  class: "text-primary fw-bolder"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-light btn-icon btn-sm",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3 m-0" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-three-dots fs-3" })
  ])
], -1)
const _hoisted_27 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary w-auto min-w-150px fw-bold",
  "data-kt-menu": "true"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-3 opacity-75" }, null, -1)
const _hoisted_29 = {
  key: 0,
  class: "menu-item px-3"
}
const _hoisted_30 = ["onClick"]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "separator mt-3 opacity-75" }, null, -1)
const _hoisted_32 = { class: "d-flex justify-content-end" }
const _hoisted_33 = {
  key: 3,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_34 = { class: "card-header" }
const _hoisted_35 = { class: "card-title m-0" }
const _hoisted_36 = { class: "card-body p-9 pb-12" }
const _hoisted_37 = {
  key: 0,
  class: "text-primary fw-bolder"
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-light btn-icon btn-sm",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3 m-0" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-three-dots fs-3" })
  ])
], -1)
const _hoisted_39 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary w-auto min-w-150px fw-bold",
  "data-kt-menu": "true"
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-3 opacity-75" }, null, -1)
const _hoisted_41 = {
  key: 0,
  class: "menu-item px-3"
}
const _hoisted_42 = ["onClick"]
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "separator mt-3 opacity-75" }, null, -1)
const _hoisted_44 = { class: "d-flex justify-content-end" }
const _hoisted_45 = {
  key: 4,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_46 = { class: "card-header" }
const _hoisted_47 = { class: "card-title m-0" }
const _hoisted_48 = { class: "card-body p-9 pb-12" }
const _hoisted_49 = {
  key: 0,
  class: "text-primary fw-bolder"
}
const _hoisted_50 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-light btn-icon btn-sm",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3 m-0" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-three-dots fs-3" })
  ])
], -1)
const _hoisted_51 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary w-auto min-w-150px fw-bold",
  "data-kt-menu": "true"
}
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-3 opacity-75" }, null, -1)
const _hoisted_53 = {
  key: 0,
  class: "menu-item px-3"
}
const _hoisted_54 = ["onClick"]
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "separator mt-3 opacity-75" }, null, -1)
const _hoisted_56 = { class: "d-flex justify-content-end" }
const _hoisted_57 = {
  key: 0,
  class: "text-primary fw-bolder"
}
const _hoisted_58 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-light btn-icon btn-sm",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3 m-0" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-three-dots fs-3" })
  ])
], -1)
const _hoisted_59 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary w-auto min-w-150px fw-bold",
  "data-kt-menu": "true"
}
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-3 opacity-75" }, null, -1)
const _hoisted_61 = {
  key: 0,
  class: "menu-item px-3"
}
const _hoisted_62 = ["onClick"]
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", { class: "separator mt-3 opacity-75" }, null, -1)
const _hoisted_64 = { class: "d-flex justify-content-end" }
const _hoisted_65 = {
  key: 5,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_66 = { class: "card-header" }
const _hoisted_67 = { class: "card-title m-0" }
const _hoisted_68 = { class: "card-body p-9 pb-12" }
const _hoisted_69 = {
  key: 0,
  class: "text-primary fw-bolder"
}
const _hoisted_70 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-light btn-icon btn-sm",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3 m-0" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bi bi-three-dots fs-3" })
  ])
], -1)
const _hoisted_71 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary w-auto min-w-150px fw-bold",
  "data-kt-menu": "true"
}
const _hoisted_72 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-3 opacity-75" }, null, -1)
const _hoisted_73 = {
  key: 0,
  class: "menu-item px-3"
}
const _hoisted_74 = ["onClick"]
const _hoisted_75 = /*#__PURE__*/_createElementVNode("div", { class: "separator mt-3 opacity-75" }, null, -1)
const _hoisted_76 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContactCard = _resolveComponent("ContactCard")!
  const _component_RegistrationCard = _resolveComponent("RegistrationCard")!
  const _component_WarehouseCard = _resolveComponent("WarehouseCard")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_InventoryCard = _resolveComponent("InventoryCard")!
  const _component_BillingCard = _resolveComponent("BillingCard")!
  const _component_FinancialCard = _resolveComponent("FinancialCard")!
  const _component_TaxCard = _resolveComponent("TaxCard")!
  const _component_EmptyBlock = _resolveComponent("EmptyBlock")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.isNullData(_ctx.contactView))
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t("kyc.information.contactInformation.title")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_ContactCard, {
              type: _ctx.getKycCommonTypeParams.entityType,
              data: _ctx.contactView
            }, {
              "after-title": _withCtx(() => [
                (_ctx.contactView.identification.kyc_level)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t("kyc.level.title")) + " " + _toDisplayString(_ctx.contactView.identification.kyc_level || "--"), 1))
                  : _createCommentVNode("", true)
              ]),
              toolbar: _withCtx(() => [
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  (_ctx.buttonShowControl(_ctx.contactView).activate)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createElementVNode("div", {
                          class: "menu-link px-3",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (
                    _ctx.onActivateButtonClick(
                      _ctx.CardComponentsType.Contact,
                      _ctx.contactView.id
                    )
                  ))
                        }, _toDisplayString(_ctx.$t("kyc.actions.activate")), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _hoisted_10
                ])
              ]),
              _: 1
            }, 8, ["type", "data"])
          ])
        ])), [
          [_directive_loading, _ctx.loading || _ctx.cardComponentsLoading[_ctx.CardComponentsType.Contact]]
        ])
      : _createCommentVNode("", true),
    (!_ctx.isNullData(_ctx.registrationView))
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t("kyc.information.registrationInformation.title")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_RegistrationCard, {
              type: _ctx.getKycCommonTypeParams.entityType,
              data: _ctx.registrationView
            }, {
              "after-title": _withCtx(() => [
                (_ctx.registrationView.identification.kyc_level)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.$t("kyc.level.title")) + " " + _toDisplayString(_ctx.registrationView.identification.kyc_level || "--"), 1))
                  : _createCommentVNode("", true)
              ]),
              toolbar: _withCtx(() => [
                _hoisted_16,
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  (_ctx.buttonShowControl(_ctx.registrationView).activate)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createElementVNode("div", {
                          class: "menu-link px-3",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (
                    _ctx.onActivateButtonClick(
                      _ctx.CardComponentsType.Registration,
                      _ctx.registrationView.id
                    )
                  ))
                        }, _toDisplayString(_ctx.$t("kyc.actions.activate")), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _hoisted_20
                ])
              ]),
              _: 1
            }, 8, ["type", "data"])
          ])
        ])), [
          [_directive_loading, 
        _ctx.loading || _ctx.cardComponentsLoading[_ctx.CardComponentsType.Registration]
      ]
        ])
      : _createCommentVNode("", true),
    (_ctx.warehouseList.length > 0)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t("kyc.information.warehouseInformation.title")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.warehouseList, (item, index) => {
              return (_openBlock(), _createBlock(_component_WarehouseCard, {
                key: index,
                type: _ctx.getKycCommonTypeParams.entityType,
                data: item,
                index: 
            index +
            (_ctx.warehousePagination.page - 1) * _ctx.warehousePagination.rowsPerPage
          
              }, {
                "after-title": _withCtx(() => [
                  (item.identification.kyc_level)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.$t("kyc.level.title")) + " " + _toDisplayString(item.identification.kyc_level || "--"), 1))
                    : _createCommentVNode("", true)
                ]),
                toolbar: _withCtx(() => [
                  _hoisted_26,
                  _createElementVNode("div", _hoisted_27, [
                    _hoisted_28,
                    (_ctx.buttonShowControl(item).activate)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                          _createElementVNode("div", {
                            class: "menu-link px-3",
                            onClick: ($event: any) => (
                    _ctx.onActivateButtonClick(_ctx.CardComponentsType.Warehouse, item.id)
                  )
                          }, _toDisplayString(_ctx.$t("kyc.actions.activate")), 9, _hoisted_30)
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_31
                  ])
                ]),
                _: 2
              }, 1032, ["type", "data", "index"]))
            }), 128)),
            _createElementVNode("div", _hoisted_32, [
              _createVNode(_component_el_pagination, {
                "current-page": _ctx.warehousePagination.page,
                "onUpdate:current-page": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.warehousePagination.page) = $event)),
                onCurrentChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateCardInfo(_ctx.CardComponentsType.Warehouse))),
                "page-size": _ctx.warehousePagination.rowsPerPage,
                "pager-count": 5,
                layout: "prev, pager, next",
                total: _ctx.warehousePagination.total,
                "hide-on-single-page": true,
                background: ""
              }, null, 8, ["current-page", "page-size", "total"])
            ])
          ])
        ])), [
          [_directive_loading, _ctx.loading || _ctx.cardComponentsLoading[_ctx.CardComponentsType.Warehouse]]
        ])
      : _createCommentVNode("", true),
    (
        _ctx.getKycCommonTypeParams.entityType === _ctx.KycType.Natural &&
        _ctx.inventoryList.length > 0
      )
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t("kyc.information.inventoryInformation.title")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_36, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inventoryList, (item, index) => {
              return (_openBlock(), _createBlock(_component_InventoryCard, {
                key: index,
                type: _ctx.getKycCommonTypeParams.entityType,
                data: item,
                index: 
            index +
            (_ctx.inventoryPagination.page - 1) * _ctx.inventoryPagination.rowsPerPage
          
              }, {
                "after-title": _withCtx(() => [
                  (item.identification.kyc_level)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(_ctx.$t("kyc.level.title")) + " " + _toDisplayString(item.identification.kyc_level || "--"), 1))
                    : _createCommentVNode("", true)
                ]),
                toolbar: _withCtx(() => [
                  _hoisted_38,
                  _createElementVNode("div", _hoisted_39, [
                    _hoisted_40,
                    (_ctx.buttonShowControl(item).activate)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                          _createElementVNode("div", {
                            class: "menu-link px-3",
                            onClick: ($event: any) => (
                    _ctx.onActivateButtonClick(_ctx.CardComponentsType.Inventory, item.id)
                  )
                          }, _toDisplayString(_ctx.$t("kyc.actions.activate")), 9, _hoisted_42)
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_43
                  ])
                ]),
                _: 2
              }, 1032, ["type", "data", "index"]))
            }), 128)),
            _createElementVNode("div", _hoisted_44, [
              _createVNode(_component_el_pagination, {
                "current-page": _ctx.inventoryPagination.page,
                "onUpdate:current-page": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.inventoryPagination.page) = $event)),
                onCurrentChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateCardInfo(_ctx.CardComponentsType.Inventory))),
                "page-size": _ctx.inventoryPagination.rowsPerPage,
                "pager-count": 5,
                layout: "prev, pager, next",
                total: _ctx.inventoryPagination.total,
                "hide-on-single-page": true,
                background: ""
              }, null, 8, ["current-page", "page-size", "total"])
            ])
          ])
        ])), [
          [_directive_loading, _ctx.loading || _ctx.cardComponentsLoading[_ctx.CardComponentsType.Inventory]]
        ])
      : _createCommentVNode("", true),
    (_ctx.financialList.length > 0)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_45, [
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t("kyc.information.financialInformation.title")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_48, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.billingList, (item, index) => {
              return (_openBlock(), _createBlock(_component_BillingCard, {
                key: index,
                type: _ctx.getKycCommonTypeParams.entityType,
                data: item,
                index: 
            index + (_ctx.billingPagination.page - 1) * _ctx.billingPagination.rowsPerPage
          
              }, {
                "after-title": _withCtx(() => [
                  (item.identification.kyc_level)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_49, _toDisplayString(_ctx.$t("kyc.level.title")) + " " + _toDisplayString(item.identification.kyc_level || "--"), 1))
                    : _createCommentVNode("", true)
                ]),
                toolbar: _withCtx(() => [
                  _hoisted_50,
                  _createElementVNode("div", _hoisted_51, [
                    _hoisted_52,
                    (_ctx.buttonShowControl(item).activate)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                          _createElementVNode("div", {
                            class: "menu-link px-3",
                            onClick: ($event: any) => (
                    _ctx.onActivateButtonClick(_ctx.CardComponentsType.Billing, item.id)
                  )
                          }, _toDisplayString(_ctx.$t("kyc.actions.activate")), 9, _hoisted_54)
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_55
                  ])
                ]),
                _: 2
              }, 1032, ["type", "data", "index"]))
            }), 128)),
            _createElementVNode("div", _hoisted_56, [
              _createVNode(_component_el_pagination, {
                "current-page": _ctx.billingPagination.page,
                "onUpdate:current-page": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.billingPagination.page) = $event)),
                onCurrentChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.updateCardInfo(_ctx.CardComponentsType.Billing))),
                "page-size": _ctx.billingPagination.rowsPerPage,
                "pager-count": 5,
                layout: "prev, pager, next",
                total: _ctx.billingPagination.total,
                "hide-on-single-page": true,
                background: ""
              }, null, 8, ["current-page", "page-size", "total"])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.financialList, (item, index) => {
              return (_openBlock(), _createBlock(_component_FinancialCard, {
                key: index,
                type: _ctx.getKycCommonTypeParams.entityType,
                data: item,
                index: 
            index +
            (_ctx.financialPagination.page - 1) * _ctx.financialPagination.rowsPerPage
          
              }, {
                "after-title": _withCtx(() => [
                  (item.identification.kyc_level)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_57, _toDisplayString(_ctx.$t("kyc.level.title")) + " " + _toDisplayString(item.identification.kyc_level || "--"), 1))
                    : _createCommentVNode("", true)
                ]),
                toolbar: _withCtx(() => [
                  _hoisted_58,
                  _createElementVNode("div", _hoisted_59, [
                    _hoisted_60,
                    (_ctx.buttonShowControl(item).activate)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                          _createElementVNode("div", {
                            class: "menu-link px-3",
                            onClick: ($event: any) => (
                    _ctx.onActivateButtonClick(_ctx.CardComponentsType.Financial, item.id)
                  )
                          }, _toDisplayString(_ctx.$t("kyc.actions.activate")), 9, _hoisted_62)
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_63
                  ])
                ]),
                _: 2
              }, 1032, ["type", "data", "index"]))
            }), 128)),
            _createElementVNode("div", _hoisted_64, [
              _createVNode(_component_el_pagination, {
                "current-page": _ctx.financialPagination.page,
                "onUpdate:current-page": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.financialPagination.page) = $event)),
                onCurrentChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.updateCardInfo(_ctx.CardComponentsType.Financial))),
                "page-size": _ctx.financialPagination.rowsPerPage,
                "pager-count": 5,
                layout: "prev, pager, next",
                total: _ctx.financialPagination.total,
                "hide-on-single-page": true,
                background: ""
              }, null, 8, ["current-page", "page-size", "total"])
            ])
          ])
        ])), [
          [_directive_loading, 
        _ctx.loading ||
        _ctx.cardComponentsLoading[_ctx.CardComponentsType.Billing] ||
        _ctx.cardComponentsLoading[_ctx.CardComponentsType.Financial]
      ]
        ])
      : _createCommentVNode("", true),
    (_ctx.taxList.length > 0)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_65, [
          _createElementVNode("div", _hoisted_66, [
            _createElementVNode("div", _hoisted_67, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t("kyc.information.taxInformation.title")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_68, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.taxList, (item, index) => {
              return (_openBlock(), _createBlock(_component_TaxCard, {
                key: index,
                type: _ctx.getKycCommonTypeParams.entityType,
                data: item,
                index: index + (_ctx.taxPagination.page - 1) * _ctx.taxPagination.rowsPerPage
              }, {
                "after-title": _withCtx(() => [
                  (item.identification.kyc_level)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_69, _toDisplayString(_ctx.$t("kyc.level.title")) + " " + _toDisplayString(item.identification.kyc_level || "--"), 1))
                    : _createCommentVNode("", true)
                ]),
                toolbar: _withCtx(() => [
                  _hoisted_70,
                  _createElementVNode("div", _hoisted_71, [
                    _hoisted_72,
                    (_ctx.buttonShowControl(item).activate)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                          _createElementVNode("div", {
                            class: "menu-link px-3",
                            onClick: ($event: any) => (
                    _ctx.onActivateButtonClick(_ctx.CardComponentsType.Tax, item.id)
                  )
                          }, _toDisplayString(_ctx.$t("kyc.actions.activate")), 9, _hoisted_74)
                        ]))
                      : _createCommentVNode("", true),
                    _hoisted_75
                  ])
                ]),
                _: 2
              }, 1032, ["type", "data", "index"]))
            }), 128)),
            _createElementVNode("div", _hoisted_76, [
              _createVNode(_component_el_pagination, {
                "current-page": _ctx.taxPagination.page,
                "onUpdate:current-page": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.taxPagination.page) = $event)),
                onCurrentChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.updateCardInfo(_ctx.CardComponentsType.Tax))),
                "page-size": _ctx.taxPagination.rowsPerPage,
                "pager-count": 5,
                layout: "prev, pager, next",
                total: _ctx.taxPagination.total,
                "hide-on-single-page": true,
                background: ""
              }, null, 8, ["current-page", "page-size", "total"])
            ])
          ])
        ])), [
          [_directive_loading, _ctx.loading || _ctx.cardComponentsLoading[_ctx.CardComponentsType.Tax]]
        ])
      : _createCommentVNode("", true),
    (_ctx.getKycCommonTypeParams.entityType === _ctx.KycType.Juridical)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
          (
          _ctx.isNullData(_ctx.contactView) &&
          _ctx.isNullData(_ctx.registrationView) &&
          _ctx.isNullData(_ctx.billingList) &&
          _ctx.isNullData(_ctx.warehouseList) &&
          _ctx.isNullData(_ctx.financialList) &&
          _ctx.isNullData(_ctx.taxList)
        )
            ? (_openBlock(), _createBlock(_component_EmptyBlock, { key: 0 }))
            : _createCommentVNode("", true)
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
          (
          _ctx.isNullData(_ctx.contactView) &&
          _ctx.isNullData(_ctx.registrationView) &&
          _ctx.isNullData(_ctx.billingList) &&
          _ctx.isNullData(_ctx.warehouseList) &&
          _ctx.isNullData(_ctx.inventoryList) &&
          _ctx.isNullData(_ctx.financialList) &&
          _ctx.isNullData(_ctx.taxList)
        )
            ? (_openBlock(), _createBlock(_component_EmptyBlock, { key: 0 }))
            : _createCommentVNode("", true)
        ], 64))
  ]))
}